// 百叶窗组件
class Blinds extends HTMLElement {
  constructor() {
    super();
    this.hoverTimeout = null;
    this.currentActive = null;
    this.gridContainer = null;
  }

  connectedCallback() {
    this.gridContainer = this.querySelector('.spx-blinds');
    const cards = this.querySelectorAll('.spx-blinds-card');

    cards.forEach((card, index) => {
      // hover 添加 active（减少防抖延迟，让响应更快）
      card.addEventListener('mouseenter', () => {
        // 清除之前的超时
        if (this.hoverTimeout) {
          clearTimeout(this.hoverTimeout);
        }

        // 减少防抖延迟，让hover响应更及时
        this.hoverTimeout = setTimeout(() => {
          if (this.currentActive !== card) {
            this.activateCard(card, index);
          }
        }, 30);
      });

      // 添加mouseleave事件，当鼠标离开时可以选择是否重置
      card.addEventListener('mouseleave', () => {
        // 可选：当鼠标离开时重置到第一个卡片
        // 这里注释掉，保持当前hover的卡片激活状态
        // this.resetToFirstCard();
      });

      // click 添加 active（防止点链接）
      card.addEventListener('click', (event) => {
        const target = event.target;
        if (target && (target instanceof HTMLElement) && (target.tagName === 'A' || target.closest('a'))) return;
        event.stopPropagation();
        this.activateCard(card, index);
      });
    });
  }

  /**
   * @param {Element} card
   * @param {number} index
   */
  activateCard(card, index) {
    // 移除所有active状态
    this.querySelectorAll('.spx-blinds-card').forEach((c) => {
      c.classList.remove('active');
    });

    // 添加active状态到当前卡片
    card.classList.add('active');
    this.currentActive = card;

    // 优化Grid布局动画
    this.optimizeGridLayout(index);
  }

  /**
   * @param {number} activeIndex
   */
  optimizeGridLayout(activeIndex) {
    if (!this.gridContainer) return;

    // 使用requestAnimationFrame确保DOM更新
    requestAnimationFrame(() => {
      // 可以在这里添加额外的Grid布局优化逻辑
      // 例如动态调整grid-template-columns等
    });
  }

  resetToFirstCard() {
    const firstCard = this.querySelector('.spx-blinds-card');
    if (firstCard) {
      this.activateCard(firstCard, 0);
    }
  }
}

customElements.define('spx-blinds', Blinds);